<template>
  <div id="dashboard">
    <div class="dash-install" v-for="install, iid in install_ids" :key="iid">
      <div class="dash-install-head">{{ iid }}</div>

      <div v-if="Object.keys(install.clients).length == 0" class="dash-missing-clients">
        No clients currently connected. Last status event received {{ getLastSeen(install.last_status) }}.
      </div>

      <div class="dash-client" v-for="client, cid in install.clients" :key="cid">

        <div class="dash-status" :class="`dash-status-${client.type}`">
          {{ client.type }}
        </div>

        <div class="dash-meta">
          <div class="dash-meta-key">message</div>
          <div class="dash-meta-val">{{ client.message }}</div>

          <div class="dash-meta-key">screen_id</div>
          <div class="dash-meta-val">{{ client.screen_id }}</div>
        </div>

        <div class="dash-meta" v-for="meta, mid in client.meta" :key="mid">
          <div class="dash-meta-key">{{ mid }}</div>
          <div class="dash-meta-val" :class="{
            'err-flash': mid == 'graphics_connected' && !meta
          }">
            {{ meta }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {formatDistanceToNow} from 'date-fns';

export default {
  data() {
    return {
      update_interval: null,
      update_interval_ms: 5000,

      // mapping of socket id : api data
      install_ids: {},
    };
  },
  methods: {
    getLastSeen(isostr){
      return formatDistanceToNow(new Date(isostr), {addSuffix: true});
    },
    update() {
      axios.get('/api/active-clients').then((res) => {
        this.$set(this, 'install_ids', res.data.installation_ids);
      });
    },
  },
  created() {
    this.update();
    this.update_interval = setInterval(this.update, this.update_interval_ms);
  },
  beforeDestroy() {
    clearInterval(this.update_interval);
  },
};
</script>

<style lang="scss" scoped>
@use '../../css/reset.scss';

html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

body {
  overflow-y: auto;
}

$bg-red: #ff5400;
$bg-orange: #ffb300;

#dashboard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  padding: 5px;

  font-size: 16px;
  line-height: 20px;

  font-family: -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;
}

.dash-install-head {
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin-bottom: 15px;
}

.dash-install {
  margin: 15px 10px;
  width: 300px;
  background-color: #f2f0ee;
  padding: 30px 10px 10px 10px;
}

.dash-client {
  margin-bottom: 20px;
}

.dash-status {
  border-radius: 5px;
  display: inline-block;
  padding: 3px 8px;
  margin-bottom: 17px;
}

.dash-client .dash-status {
  margin-top: 30px;
}
.dash-client:nth-child(1) .dash-status{
  margin-top: 0;
}

.dash-meta {
  font-size: 0.8rem;
  line-height: 0.8rem;
}
.dash-meta-key {
  font-weight: 700;
}
.dash-meta-val {
  margin-bottom: 6px;
}

.dash-status-ready {
  background-color: #19b760;
  color: white;
}

.dash-status-error {
  background-color: $bg-red;
  color: white;
}

.dash-status-syncing {
  background-color: $bg-orange;
  color: white;
}

.dash-missing-clients {
  background-color: $bg-red;
  padding: 4px;
  color: white;
  font-size: 0.75rem;
  line-height: 0.75rem;
  border-radius: 4px;
}

.err-flash {
  background-color: $bg-red;
  border-radius: 3px;
  color: white;
  padding: 0 4px;
  animation-name: flashy;
  animation-play-state:running;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-duration: 75ms;
}

@keyframes flashy {
  0% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
</style>
